if (!customElements.get('er-campaign-countdown')) {
  customElements.define('er-campaign-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.hidden = true;
      const deadlineText = (this.dataset.deadline || '').trim();
      const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:Z|[+-]\d{2}:\d{2})$/i.exec(deadlineText);
      if (!parts) return;
      const month = Number(parts[2]);
      const day = Number(parts[3]);
      if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(Number(parts[1]), month, 0)).getUTCDate() || Number(parts[4]) > 23 || Number(parts[5]) > 59 || Number(parts[6] || 0) > 59) return;
      this.deadline = Date.parse(deadlineText);
      if (!Number.isFinite(this.deadline)) return;
      this.clock = this.querySelector('[data-countdown-clock]');
      this.live = this.querySelector('[data-countdown-live]');
      this.days = this.querySelector('[data-countdown-days]');
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      if (!this.clock || !this.live || !this.days || !this.hours || !this.minutes) return;
      this.update();
      if (this.deadline > Date.now()) this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      if (this.interval !== undefined) {
        window.clearInterval(this.interval);
        this.interval = undefined;
      }
    }

    update() {
      const remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        this.stop();
        this.clock.hidden = true;
        this.live.hidden = this.dataset.expiryMode !== 'live';
        this.hidden = this.dataset.expiryMode !== 'live';
        return;
      }
      const totalMinutes = Math.floor(remaining / 60000);
      const values = [Math.floor(totalMinutes / 1440), Math.floor(totalMinutes / 60) % 24, totalMinutes % 60];
      [this.days, this.hours, this.minutes].forEach((node, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (node.textContent !== value) node.textContent = value;
      });
      this.clock.hidden = false;
      this.live.hidden = true;
      this.hidden = false;
    }
  });
}

{
  const deadline = Date.parse(document.querySelector('meta[name="er-campaign-deadline"]')?.content || '');
  let expiryTimer;
  const updateCampaignExpiry = () => {
    if (!Number.isFinite(deadline)) return;
    if (expiryTimer !== undefined) window.clearTimeout(expiryTimer);
    const remaining = deadline - Date.now();
    if (remaining > 0) {
      expiryTimer = window.setTimeout(updateCampaignExpiry, Math.min(remaining, 2147483647));
      return;
    }
    document.documentElement.classList.add('er-campaign-expired');
    document.querySelectorAll('[data-er-campaign-reset-text]').forEach((node) => {
      node.textContent = node.dataset.erCampaignResetText;
      if (node.dataset.erCampaignResetUrl) node.setAttribute('href', node.dataset.erCampaignResetUrl);
    });
  };
  updateCampaignExpiry();
  window.addEventListener('pageshow', updateCampaignExpiry);
  document.addEventListener('visibilitychange', updateCampaignExpiry);
}
